<template>
  <div class="community_content_list" v-if="communityTabList.length">
    <!-- 分类及列表数据 -->
    <van-tabs
      ref="tabRef"
      v-model="currentId"
      @click="changeIndex"
      sticky
      :swipe-threshold="3"
    >
      <van-tab
        v-for="(item, index) in communityTabList"
        :title="item.name"
        :key="item.id + item.name"
        :name="item.id"
      >
        <van-list
          :key="item.id"
          v-if="communityTabList.length > 1 && item.id == currentId"
          v-model="pageParams.loading"
          :error.sync="pageParams.error"
          :finished="pageParams.finished"
          :finished-text="pageParams.bottomText"
          :immediate-check="false"
          error-text="请求失败，点击重新加载"
          @load="getArticleList()"
        >
          <waterfallComponents
            :ref="'waterfall' + item.id"
            class="water-fall"
            :upDownGap="6"
            :leftRightGap="6"
            :pageMargin="12"
            @clickHander="clickHander"
            @styleEnd="styleEnd"
          >
            <template slot-scope="props">
              <div :data="JSON.stringify(props.data)" class="info">
                <div
                  v-lazy:background-image="props.data.coverUrl"
                  class="info-img"
                  style="height: 230px"
                ></div>
                <div class="bottom-content">
                  <p class="item-title">
                    {{ props.data.content }}
                  </p>
                  <div class="item-tagAndPlaynum">
                    <p class="item-user">
                      <img :src="props.data.headImg" />
                      <span>{{ props.data.nickName }}</span>
                    </p>
                    <p class="item_playnum" @click.stop="handleLike(props.data, props.index)">
                      <img
                        :src="
                          props.data.likeState
                            ? require('../../../assets/images/community/liked.png')
                            : require('../../../assets/images/community/like.png')
                        "
                      />
                      <span>{{ fomatterNum(props.data.likeNum, false) || 0 }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </template>
          </waterfallComponents>
          <template #finished>
            <img
              src="@/assets/images/expertsView/pentagram.png"
              style="width: 9px"
            />
            我们会加油更新的 么么哒~
            <img
              src="@/assets/images/expertsView/pentagram.png"
              style="width: 9px"
            />
          </template>
        </van-list>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
import Index from "./index";
export default Index;
</script>

<style lang="less" scoped>
@import "./index.less";
</style>